import { httpClient } from './httpClient';

const base = '/api/cursos';

export const listarCursos = () => httpClient.get(base);
export const obtenerCurso = (id) => httpClient.get(`${base}/${id}`);
export const listarCursosPorCentro = (centroId) => httpClient.get(`${base}/centro/${centroId}`);
export const listarVariantesCurso = (cursoId) => httpClient.get(`${base}/${cursoId}/variantes`);
export const crearCurso = (payload) => httpClient.post(base, payload);
export const actualizarCurso = (id, payload) => httpClient.put(`${base}/${id}`, payload);
export const eliminarCurso = (id) => httpClient.del(`${base}/${id}`);

const cursosService = {
  listar: listarCursos,
  obtener: obtenerCurso,
  listarPorCentro: listarCursosPorCentro,
  listarVariantes: listarVariantesCurso,
  crear: crearCurso,
  actualizar: actualizarCurso,
  eliminar: eliminarCurso,
};

export default cursosService;
